import React from "react";
import "./Experience.css";

const experienceData = [
  {
    company: "Soft Skills Club, NIT Jamshedpur",
    role: "Joint Secretary",
    duration: "2024 - Present",
    description: `Coordinated high-impact events including Interactive Session with Ashish Akshat (JPSC Topper), Career Opportunities in Tata Steel: An Alumnus Perspective with Akhilesh Mishra (Chief, Operations & New Initiatives, Tata Steel), and Personal Interview Success Strategies seminar; contributed to fostering innovation and professional development among students.`,
  },
  {
    company: "Petaverse",
    role: "Co-founder",
    duration: "2025 - Present",
    description: `Developed Petaverse, a comprehensive pet care application offering services like breeding, training, grooming, selling, adoption, vet services, and community engagement.
Implemented key features such as pet profile management, shelter locator, marketplace for pet accessories, and a training section with video tutorials.`,
  },

  {
    company: "Tata Steel Internship",
    role: "Industrial Trainee",
    duration: "Summer 2025",
    description: `Studied BOF steelmaking (bath 1.2–1.9 m) focusing on vessel design & refractory wear.
Found FeO-rich slag (>5%) & low CaO/SiO₂ basicity causing MgO–C dissolution (up to 99.9% C loss) & low-melting phase formation.
Observed thermal spalling from ~1,600–1,700 °C cycles & mechanical erosion from scrap impact.
BOF1: higher basicity, lower FeO & SiO₂ (13.95% vs 14.15%) → longer refractory life.
Recommended fine scrap cushioning, controlled drop, optimized sizing & 5°–8° tilt.
Applied Archard’s wear law & impact energy equation (E = mgh) for wear quantification.
Correlated operational data with wear patterns to develop preventive maintenance insights.`,
  },
  {
    company: "Team Innoreva, NIT Jamshedpur",
    role: "App Developer & IoT",
    duration: "Feb 2024 – Present",
    description:
      "Developed Pedaller, a mobile application that enables users to book and lend bicycles on a cost basis, improving campus transportation accessibility.",
  },
  {
    company: "Team Daksh, NIT Jamshedpur",
    role: "Coordinator",
    duration: "Jan 2024 – Present",
    description:
      "Led fabrication, optimization, and testing of off-road vehicles for BAJA SAE competition; managed event logistics and gained hands-on vehicle mechanics experience.",
  },
];

function Experience() {
  return (
    <section id="experience" className="experience-section">
      <div className="container">
        <h2 className="section-title">Experience</h2>
        <div className="timeline">
          <div className="timeline-line"></div>
          {experienceData.map(
            ({ company, role, duration, description }, idx) => (
              <div key={idx} className="timeline-item">
                <div className="timeline-dot"></div>
                <div className="timeline-content">
                  <h3>{company}</h3>
                  <span className="role">{role}</span>
                  <span className="duration">{duration}</span>
                  <p>{description}</p>
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </section>
  );
}

export default Experience;
